import StaticHeaderThree from './component.styles'
export default StaticHeaderThree
